module.exports = [{
      plugin: require('../.yarn/unplugged/gatsby-virtual-25d7ee3bd4/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
